export type CookieType = {
  key: string;
  title: string;
  description: string;
  required?: boolean;
};

export const defaultCookies: CookieType[] = [
  { key: "essential", title: "Essential Cookies", description: "Required for basic website functionality.", required: true },
  { key: "performance", title: "Performance Cookies", description: "Help improve website performance and analytics." },
  { key: "functional", title: "Functional Cookies", description: "Remember your preferences and settings." },
  { key: "advertising", title: "Advertising Cookies", description: "Used to show relevant ads based on your interests." },
  { key: "thirdParty", title: "Third-Party Cookies", description: "Set by external services embedded on this site." },
  { key: "optional", title: "Optional / Custom Cookies", description: "Additional cookies you can consent to." },
];

export type CookieLayout = "modal" | "sidebar" | "center";

export interface CookieConsentProps {
  cookies?: CookieType[];
  detailedLayout?: CookieLayout; // layout for detailed view
}